import styled from 'styled-components'

export const Wrapper = styled.div`
    background: white;
    box-sizing: border-box;
    width: 200px;
    box-shadow: rgba(0, 0, 0, 0.3) 1px 2px 5px;
    padding: 8px 0;
`
